import React from 'react';

import FullAdminPanel from './FullAdminPanel';

export default function AdminPanel() {
  return <FullAdminPanel />;
}
